import { combineReducers } from 'redux';

import {
    REQUEST_FORM_SUBMIT_PAYMENT,
    SUCCESS_FORM_SUBMIT_PAYMENT,
    FAILURE_FORM_SUBMIT_PAYMENT,
    RESET_FORM_SUBMIT_PAYMENT,
    SET_TIMEOUT_ID,
    CLEAR_TIMEOUT_ID
} from './constants';

const requesting = (state = false, action) => {
    switch (action.type) {
        case REQUEST_FORM_SUBMIT_PAYMENT:
            return true;
        case SUCCESS_FORM_SUBMIT_PAYMENT:
        case FAILURE_FORM_SUBMIT_PAYMENT:
        case RESET_FORM_SUBMIT_PAYMENT:
            return false;
        default:
            return state;
    }
};

const success = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_FORM_SUBMIT_PAYMENT:
            return true;
        case REQUEST_FORM_SUBMIT_PAYMENT:
        case FAILURE_FORM_SUBMIT_PAYMENT:
        case RESET_FORM_SUBMIT_PAYMENT:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_FORM_SUBMIT_PAYMENT:
            return action.response.message;
        case SUCCESS_FORM_SUBMIT_PAYMENT:
        case REQUEST_FORM_SUBMIT_PAYMENT:
        case RESET_FORM_SUBMIT_PAYMENT:
            return '';
        default:
            return state;
    }
};

const resetTimeoutId = (state = -1, action) => {
    switch (action.type) {
        case SET_TIMEOUT_ID:
            return action.timeoutId;
        case CLEAR_TIMEOUT_ID:
        case RESET_FORM_SUBMIT_PAYMENT:
            return -1;
        default:
            return state;
    }
};

export default combineReducers({
    requesting,
    success,
    error,
    resetTimeoutId
});



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/request/reducer.js